"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminsAccessBrandsCtl_1 = require("./shared/controllers/AdminsAccessBrandsCtl");
var AdminsAccessAffilateCtl_1 = require("./shared/controllers/AdminsAccessAffilateCtl");
var AdminsAccessGwsGameProvidersCtl_1 = require("./shared/controllers/AdminsAccessGwsGameProvidersCtl");
var coreDialog_1 = require("./coreDialog");
var AdminsAccessUsrPermissionsCtl_1 = require("./shared/controllers/AdminsAccessUsrPermissionsCtl");
var ACCESS = /** @class */ (function () {
    function ACCESS() {
    }
    Object.defineProperty(ACCESS, "AdminAccessUsrPermissions", {
        get: function () {
            if (!this._AdminAccessUsrPermission) {
                this._AdminAccessUsrPermission = new AdminsAccessUsrPermissionsCtl_1.AdminsAccessUsrPermissionsCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AdminAccessUsrPermission;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ACCESS, "AdminAccessBrands", {
        get: function () {
            if (!this._AdminsAccessBrands) {
                this._AdminsAccessBrands = new AdminsAccessBrandsCtl_1.AdminsAccessBrandsCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AdminsAccessBrands;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ACCESS, "AdminAccessAffilates", {
        get: function () {
            if (!this._AdminsAccessAffilates) {
                this._AdminsAccessAffilates = new AdminsAccessAffilateCtl_1.AdminsAccessAffilateCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AdminsAccessAffilates;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ACCESS, "AdminAccessGwsGameProvider", {
        get: function () {
            if (!this._AdminsAccessGwsGameProvider) {
                this._AdminsAccessGwsGameProvider = new AdminsAccessGwsGameProvidersCtl_1.AdminsAccessGwsGameProviderCtl(coreDialog_1.DIALOG.DialogApiError);
            }
            return this._AdminsAccessGwsGameProvider;
        },
        enumerable: true,
        configurable: true
    });
    return ACCESS;
}());
exports.ACCESS = ACCESS;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/coreAccess.ts
// module id = 2158
// module chunks = 0